import SeparatedBars from '@crehana/icons/SeparatedBars';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

export const CourseTag = styled.div<{ background?: string; color?: string }>(
  ({ theme, background, color }) => css`
    padding: 4px 8px;
    border-radius: 5px;
    background-color: ${background ? background : theme.colors.primary.lighter};
    color: ${color ? color : theme.colors.white};
  `,
);

export const WrapperMetrics = styled.div<{
  isDark: boolean;
  isLoading?: boolean;
}>(
  ({ theme, isDark, isLoading }) => css`
    width: ${isLoading ? 'auto' : 'max-content'};
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    padding: 12px 16px;
    border-radius: 10px;
    background-color: ${
      isDark ? theme.colors.base['light-dark-mode'] : theme.colors.gray.lighter
    };

    ${theme.breakpoints.down('sm')} {
      width: auto;
    }
  `,
);

export const LevelCourse = styled(SeparatedBars)<{
  isDark: boolean;
  level: number;
}>(
  ({ theme, isDark, level }) => css`
    rect {
      &:nth-child(-n + ${level}) {
        fill: ${
          isDark ? theme.colors.secondary.main : theme.colors.primary.main
        };
      }
    }
  `,
);
